module.exports = __webpack_public_path__ + "static/media/icon-toggle-tick.35c23cb1.svg";